module.exports = __webpack_public_path__ + "img/contact.9c50530.svg";